import { requestApi } from '../util/network'

export const getWithdrawList =
(params) =>
  requestApi(
    '/Memberfund/pdcashlist',
    'POST',
    {
      page: params.page,
      per_page: params.per_page
    },
    'member'
  )
export const getWithdrawListGoldBalance =
(params) =>
  requestApi(
    '/Memberfund/pdcashlist_gold_card_balance',
    'POST',
    {
      page: params.page,
      per_page: params.per_page
    },
    'member'
  )
export const addWithdraw =
    (pdcAmount, memberbankId, password, form_token, addressType, emailCode) =>
      requestApi(
        '/Recharge/pd_cash_add',
        'POST',
        {
          pdc_amount: pdcAmount,
          memberbank_id: memberbankId,
          password: password,
          form_token:form_token,
          addressType: addressType,
          email_code: emailCode
        },
        'member'
      )
export const addGoldCardBalanceWithdraw =
    (pdcAmount, memberbankId, password, form_token, addressType, emailCode) =>
      requestApi(
        '/Recharge/pd_cash_add_gold',
        'POST',
        {
          pdc_amount: pdcAmount,
          memberbank_id: memberbankId,
          password: password,
          form_token:form_token,
          addressType: addressType,
          email_code: emailCode
        },
        'member'
      )
export const createToken = () =>requestApi(
    '/token/create',
    'POST',
    {
    },
    'member'
)